import { createAppSlice } from "../../app/createAppSlice";
import type { AppSettingsType } from "../../config/global";

const initialState: AppSettingsType = window.appSettings;

export const envSlice = createAppSlice({
  name: "env",
  initialState: initialState,
  reducers: {},
  selectors: {
    artesianSelector: s => s.serviceUrl,
    meteringProviderSelector: s => s.meteringProvider,
    curveExcelBlobUrlSelector: s => s.curveExcelBlobUrl,
    authConnectionSelector: s => s.authConnection,
  },
});

// eslint-disable-next-line @typescript-eslint/unbound-method
export const appSettingsSelector = envSlice.selectSlice;
export const { artesianSelector, meteringProviderSelector, curveExcelBlobUrlSelector, authConnectionSelector } =
  envSlice.selectors;
